// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"231":"blueprint-icons-split-paths-by-size-loader","824":"blueprint-icons-all-paths-loader"}[chunkId] || chunkId) + "." + {"231":"1f16eb6f","453":"ca0b38ab","824":"ca1deb94"}[chunkId] + ".chunk.js";
};